import * as React from 'react';
import { ChangeEvent, FormEvent, FormEventHandler, useCallback, useState } from 'react';

import classNames from 'classnames';
import { authorizationService } from '../../models/AuthorizationService';
import { useRedirectBack } from '../../hooks/useRedirectBack';

import style from './Authorize.module.css';

export function Authorize() {
  const { redirectBack, targetConfigurator } = useRedirectBack();
  const [token, setToken] = useState('');
  const changeToken = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setHasError(false);
      setToken(e.target.value);
    },
    [token],
  );
  const [errorMessage, setErrorMessage] = useState('');
  const [hasError, setHasError] = useState(false);

  const authorize: FormEventHandler<HTMLFormElement> = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      if (token) {
        const isAuthorized = authorizationService.authorize(token);
        if (isAuthorized) {
          redirectBack();
        } else {
          setHasError(true);
          setErrorMessage(targetConfigurator ? `Invalid token for ${targetConfigurator}` : `Invalid token`);
        }
      }
    },
    [token, authorizationService],
  );

  const authorizeMessage = targetConfigurator ? `Authorize to ${targetConfigurator}` : 'Authorize';
  return (
    <div className={style.root}>
      <div className={style.container}>
        <div className={style.formCard}>
          <div className={style.formCardHeader} title={authorizeMessage}>
            {authorizeMessage}
          </div>
          <form className={style.form} onSubmit={authorize}>
            <div className={style.formCardBody}>
              <div className={style.formControl}>
                <label htmlFor="token">Token</label>
                <input id="token" type="password" autoFocus value={token} onChange={changeToken} />
              </div>
            </div>
            <div className={style.formCardFooter}>
              <button type="submit" className={style.authorizeBtn} disabled={!token}>
                OK
              </button>
            </div>
          </form>
        </div>
        <p
          className={classNames(style.errorMessage, {
            [style.visuallyHidden]: !hasError,
          })}
        >
          {errorMessage}
        </p>
      </div>
    </div>
  );
}
